import { createStore, applyMiddleware, compose } from 'redux';
import { thunk as reduxThunk } from 'redux-thunk';
import rootReducers from "../reducers";
import history from '../history';
import { connectRouter, routerMiddleware } from 'connected-react-router';

const composeEnhancers = 
  (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const store = createStore(
  connectRouter(history)(rootReducers),
  composeEnhancers(
    applyMiddleware(reduxThunk, routerMiddleware(history))
  )
);
